import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { logPageView } from '../services/analytics';

export default function PageViewTracker({ children }: { children: React.ReactNode }) {
    const location = useLocation();

    useEffect(() => {
        // Track page view on route change
        logPageView(location.pathname + location.search);
    }, [location]);

    return <>{children}</>;
}
